import { FC, useEffect } from "react";
import { RouteObject, useRoutes } from "react-router-dom";
import Company from "@/pages/company";
import ContactUs from "@/pages/contact-us";

// The standalone marketing pages (/company, /contact-us) run under a
// BrowserRouter on real paths, just like the articles section. Any path that
// is not one of these pages is a main-site (hash-routed) destination, so we
// hand it back to the hash-routed main site with a full page load.
const RedirectToMain: FC = () => {
  useEffect(() => {
    const { pathname, search } = window.location;
    window.location.replace(`/#${pathname}${search}`);
  }, []);
  return null;
};

export const routes: RouteObject[] = [
  {
    path: "/company",
    element: <Company />,
  },
  {
    path: "/contact-us",
    element: <ContactUs />,
  },
  {
    path: "*",
    element: <RedirectToMain />,
  },
];

const PagesRouter: FC = () => {
  return useRoutes(routes);
};

export default PagesRouter;
